export default "__VITE_ASSET__DSfPPQXf__"